export const ActualLastYear = {
    "columns": 6,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "combo",
        "colorTheme": 'colorTheme1',
        "title": "Actual Sales vs Last Year (% Growth)",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [

                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    },
                    {
                        "name": 'LY Sales',
                        "value": 'LYSales',
                        "type": 'column'
                    },
                    {
                        "name": 'Growth %',
                        "value": 'Growth',
                        "type": 'line',
                        "percent": true
                    }
                ],
                "title": "Month",
                "endpoint": "N33",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {

                    }
                }
            }
        }
    }
}
